import React from 'react';
import FlightCard from './FlightCard';
import useIsMobileView from "../../../../../hooks/useIsMobileView";

export default ({
  flightGroupData = {},
  onEditFlight,
  onDeleteFlight
}) => {
  const isMobileView = useIsMobileView();

  const {
    Departing,
    Returning,
  } = flightGroupData;

  return (
      <div style={{
        display: 'flex',
        // flex: 1,
        flexDirection: isMobileView ? 'column' : 'row',
        // padding: '20px',
        gap: '20px',
        // alignItems: isMobileView ? 'flex-start' : 'center'
      }}>
        {
          Departing ?
          <FlightCard flightGroupData={flightGroupData} flightData={Departing} onEditFlight={onEditFlight} onDeleteFlight={onDeleteFlight} />
          :
          <div style={{ flex: 1, padding: '20px' }}>&nbsp;</div>
        }
        {
          Returning ?
          <FlightCard flightGroupData={flightGroupData} flightData={Returning} onEditFlight={onEditFlight} onDeleteFlight={onDeleteFlight} />
          :
          <div style={{ flex: 1, padding: '20px' }}>&nbsp;</div>
        }
      </div>
  )
}